import React, { useContext, useMemo } from 'react';
import clsx from 'clsx';
import { Styled } from './index.styles';
import { HotelInformation } from '../../../molecules/LeftColumn/index';
import { HotelPetPolicy } from '../../../molecules/PetPolicy/index';
import { HotelParking } from '../../../molecules/Parking/index';
import { serverData } from '../HotelInformation';
import { useCheckBreakpoint } from '../../../hooks';
import { usePageContext } from '../../../context/PageContext';
import { hotelInformationMockData } from '../mock/hotelInformation';
import { useHQVContext } from '../../../context/HQVContext';
import { useSearchResultsStore } from '../../../modules/store/searchResultsStore';

export const Information: React.FC = () => {
  const { jsonContent } = useContext(serverData);
  const { hqvState } = useHQVContext();
  const { pageState, isAuthorMode } = usePageContext();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const informationData = useSearchResultsStore((state: { propertyInfoData: any }) => state.propertyInfoData);

  const hotelInformationData = useMemo(() => {
    return pageState?.authorMode || isAuthorMode
      ? hotelInformationMockData.hotelInformationData
      : informationData?.propertyInfoData;
  }, [pageState?.authorMode, informationData, isAuthorMode]);

  const isViewportL = useCheckBreakpoint('viewportL');

  return (
    <Styled>
      <div
        className={clsx(
          'information-component',
          'adjustable-margin-element',
          `${hqvState.modalOpenState ? 'hqv-modal' : ''}`
        )}
        id="hqv-hotel-info-section"
      >
        <h2 className={clsx(isViewportL ? 't-title-s' : 't-subtitle-xl', 'component-heading')}>
          {jsonContent?.propertyInformationLabel}
        </h2>
        <div className="component-content">
          <HotelInformation hotelInformationData={hotelInformationData} />
          <HotelPetPolicy hotelInformationData={hotelInformationData} />
          {hotelInformationData?.property?.parking?.length !== 0 && (
            <HotelParking hotelInformationData={hotelInformationData} />
          )}
        </div>
        <div className="component-content-small-screen">
          <div className="left-content">
            <HotelInformation hotelInformationData={hotelInformationData} />
          </div>
          <div className="right-content">
            <HotelPetPolicy hotelInformationData={hotelInformationData} />
            {hotelInformationData?.property?.parking?.length !== 0 && (
              <HotelParking hotelInformationData={hotelInformationData} />
            )}
          </div>
        </div>
      </div>
    </Styled>
  );
};
